import { Pages, PagesResponse, Page } from 'ducks/pages/models'

export const parsePagesContent = ({ pages }: PagesResponse): Pages => {
  const page: Page = pages[0]
  return {
    pages: page,
  }
}
